var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1100PorcentConnected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 49.76v16.67l-8.75-9.3L71 49.76zM54 26.83a3.09 3.09 0 002.44 3.09A3 3 0 0060 27v-1h9v-4c0-.26-3.89.75-3.89-6.88A8.17 8.17 0 0059 7V4.31a2.23 2.23 0 00-1.5-2.18A1.92 1.92 0 0055 4v3a8 8 0 00-6 8.06v.88a9.599 9.599 0 01-.86 4A3.61 3.61 0 0145 22v4h9v.83zm2.06 31.59L68.43 48H44.32l11.74 10.42zm0 4l-3-2.65L45.31 67h22.11L60 59.07l-3.94 3.35zM63.12 30A7 7 0 0160 33.21V44h4V30h-.88zM42 50v16l8.77-8.26L42 50zm-.45-30a4 4 0 013-2 7.36 7.36 0 00.33-2H4v39h8v14.56L29.75 55H39v-4H28.33L16 61.12V51H8V20h33.55z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_100porcent_connected.5a897cb8.svg";
export { SvgH1100PorcentConnected as ReactComponent };